import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

export const DEIPageFurtherReadingSectionSECTION = styled.section`
  padding: 50px 0 70px;  

  .Card figure {
    margin-bottom: var(--spacing--S);
  }
`;

export const DEIPageDEIUpdatesContentDIV = styled.div`
  text-align: center;
  margin-bottom: 85px;
30
  .TextLink {
    color: var(--color--cobalt-600);
  }
`

export const DEIPageFurtherReadingSectionContentDIV = styled.div`
  text-align: center;

  h3 {
    margin: 0 0 20px;
  }

  p {
    color: var(--color--text-default);
    margin: 0 0 var(--spacing--M);
  }
`;

export const DEIPageFurtherReadingSectionCardsDIV = styled.div`
  display: grid;
  gap: 30px;
  margin: 50px 0 0;

  a {
    padding-bottom: 10px;
    border-bottom: 1px solid var(--color--charcoal-300);
  }

  ${MEDIA_QUERIES.S} {
    gap: 60px;
    grid-template-columns: repeat(2, 1fr);
  }

  ${MEDIA_QUERIES.M} {
    gap: 80px;
    grid-template-columns: repeat(4, 1fr);
  }
`;
